import Article from "./article";

export default function ShowCaseArticle() {
  return <Article requireCategory="showcase" showComments={true} />;
}
